<app-form-group
    [userListBase]="userListBase"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-group>
